import { PartialPassFragment } from "@/__generated__/graphql";

export const passHasBranchAccess = (pass: PartialPassFragment, lessonBranchRecId: string | undefined | null) => {
  const branchRecIds = pass.kind?.branchRecIds || [];
  return !lessonBranchRecId || branchRecIds.length === 0 || branchRecIds.includes(lessonBranchRecId);
};
